module.exports = __webpack_public_path__ + "static/img/Portrait-Sonia.1eebe56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Portrait-Sonia.jpg
// module id = 6Snr
// module chunks = 1